import ClientOAuth2 from "client-oauth2";
import axios from "axios";
import { setAuthHeader } from "../utils/axiosHeaders";
import { storeUserError, storeUser, userSignedOut, /*loadingUser,*/ } from "../actions/authActions";
import store from "../store";

const config = {
    clientId: `${process.env.REACT_APP_CLIENT_ID}`,
    accessTokenUri: `${process.env.REACT_APP_AUTH_SERVER_URL}/connect/token`,
    userInfoUri: `${process.env.REACT_APP_AUTH_SERVER_URL}/connect/userinfo`,
    endsessionUri: `${process.env.REACT_APP_AUTH_SERVER_URL}/connect/endsession`,
    introspectURL: `${process.env.REACT_APP_AUTH_SERVER_URL}/connect/introspect`,
    passwordURL: `${process.env.REACT_APP_AUTH_SERVER_URL}/password`,
    scopes: ["openid", "profile", "roles", "offline_access"],
};
const oauth = new ClientOAuth2(config), storageItem = "token";
const __worker = !(window.location.pathname.startsWith('/vl') || window.location.pathname.startsWith('/vc') || window.location.pathname.startsWith('/pdf') || window.location.pathname.startsWith('/pdfweb')) ? window.__worker || new Worker('authWorker.js') : null;

export async function loadUserFromStorage(store) {
    try {
        if (window.__worker == null)
            window.__worker = __worker;
        if (window.__tokenChanged == null) {
            window.__tokenChanged = new Event("tokenChanged");
            console.log("tokenChanged CREATED");
        }
        let user = await userProfile();
        !user ? store.dispatch(storeUserError()) : store.dispatch(storeUser(user.data));
        if (user) {
            console.log('loadUserFromStorage con user');
            if (!__worker.onmessage) {
                console.log('loadUserFromStorage sin __worker.onmessage');
                var tk = JSON.parse(atob(localStorage.getItem(storageItem)));
                var tt = (tk.timeout - new Date().getTime()) - 20000;
                __worker.postMessage({ type: 'cleartimeout' });
                __worker.postMessage({ type: 'timeout', timeout: tt });
                __worker.onmessage = (e) => refreshToken(tk.rt);
            }
        } else {
            __worker.postMessage({ type: 'cleartimeout' });
            __worker.onmessage = null;
        }
    } catch (e) {
        store.dispatch(storeUserError());
    }
}
export const login = (params) => {
    return oauth.owner
        .getToken(params.email, params.password)
        .then((result) => {
            var tk = JSON.parse(atob(result.accessToken.split('.')[1]));
            localStorage.setItem(storageItem, btoa(JSON.stringify({
                at: result.accessToken,
                rt: result.refreshToken,
                timeout: new Date(new Date().getTime() + ((tk.exp - tk.auth_time) * 1000)).getTime(),
            })));
            setAuthHeader(result.accessToken);
            loadUserFromStorage(store);
            return { token: result};
        })
        .catch((error) => {
            localStorage.removeItem(storageItem);
            return { error: error };
        });
};
export const logoff = () => {
    __worker.postMessage({ type: 'cleartimeout' });
    __worker.onmessage = null;
    userSignedOut();
};
export const userProfile = () => {
    //store.dispatch(loadingUser());
    var token = localStorage.getItem(storageItem);
    if (!token) return null;
    var tk = JSON.parse(atob(token));
    if (tk && tk.at) {
        setAuthHeader(tk.at);
        return axios.get(config.userInfoUri);
    } else {
        return null;
    }
};
export const refreshToken = (token) => {
    console.log((new Date()).toLocaleString() + " *** refreshToken ***");
    return new ClientOAuth2.Token(oauth, { refresh_token: token })
        .refresh(config)
        .then((result) => {
            var tk = JSON.parse(atob(result.accessToken.split('.')[1]));
            localStorage.removeItem(storageItem);
            localStorage.setItem(storageItem, btoa(JSON.stringify({
                at: result.accessToken,
                rt: result.refreshToken,
                timeout: new Date(new Date().getTime() + ((tk.exp - tk.iat) * 1000)).getTime(),
            })));
            __worker.onmessage = null;
            setAuthHeader(result.accessToken);
            loadUserFromStorage(store);
            try {
                if (window.__tokenChanged !== null)
                    window.dispatchEvent(window.__tokenChanged);
            } catch (x) {
                console.log(x);
            }
            return result;
        })
        .catch((error) => {
            if (axios.isCancel(error)) {
                setTimeout(() => refreshToken(token), 2000);
                console.log('Request aborted - resending');
            }
            console.log(error);
            logoff();
        });
};
export const validateToken = (token) => {
    return axios
        .post(config.introspectURL, { token: token }, { headers: { "Content-Type": "application/x-www-form-urlencoded", } })
        .then((result) => {
            console.log("validateToken - introspect result:");
            console.log(result);
        })
        .catch((error) => {
            console.error(error);
        });
};
export const passwordChange = (params) => {
    return axios
        .post(config.passwordURL, params,)
        .then((result) => true)
        .catch((error) => false);
};

export default oauth;